/* Elvy accessory product page - generic variant picker, gallery, dialogs and add to cart.
   Built 2026-10-11 by Donna. Pairs with sections/elvy-accessory.liquid and assets/elvy-proshield.css. */
(function () {
  'use strict';
  var root = document.getElementById('elvy-accessory');
  var dataEl = document.getElementById('elvy-accessory-data');
  if (!root || !dataEl) return;

  var config = JSON.parse(dataEl.textContent);
  var variants = config.variants;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var COLORS = {
    'navy blue': '#1f2a5a', 'navy': '#1f2a5a', 'royal blue': '#2449a8', 'blue': '#1e5bb8', 'skyblue': '#8fc3e8', 'sky blue': '#8fc3e8', 'light blue': '#a9cfe9',
    'green': '#2e7d32', 'sea green': '#7fc6b6', 'mint green': '#a8dcc6', 'gray': '#8a8a85', 'grey': '#8a8a85', 'black': '#232323',
    'white': '#f6f6f4', 'brown': '#7a4a2a', 'red': '#b3261e', 'orange': '#e07b24', 'pink': '#f2b6c6', 'nude': '#e5c4a8', 'peach': '#f3c1a2'
  };
  var LIGHT = ['white', 'pink', 'nude', 'skyblue', 'sky blue', 'light blue', 'mint green', 'peach', 'sea green'];

  var start = variants.filter(function (v) { return v.id === config.current; })[0] || variants[0];
  var selected = start.options.slice();
  var quantity = 1;
  var submitting = false;
  var lastFocus = null;

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100);
  }

  function findVariant(opts) {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  }

  function setMain(src, alt, label) {
    var img = $('#main-photo');
    img.src = src; img.alt = alt;
    $('#image-label').textContent = label || '';
    $$('.thumb').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.src.split('?')[0] === src.split('?')[0])); });
  }

  $$('.swatch').forEach(function (b) {
    var key = (b.dataset.value || '').toLowerCase();
    b.style.setProperty('--color', COLORS[key] || '#cac8e5');
    if (LIGHT.indexOf(key) !== -1) b.classList.add('is-light');
  });

  var anyAvailable = variants.some(function (v) { return v.available; });

  function availableWith(i, value) {
    return variants.some(function (v) { return v.available && v.options[i] === value; });
  }

  // Hide option values that have no stock in any combination (they come back on their own when restocked).
  if (anyAvailable) {
    $$('[data-opt]').forEach(function (b) {
      if (!availableWith(+b.dataset.opt, b.dataset.value)) b.hidden = true;
    });
  }

  // Start on an available combination.
  var startV = findVariant(selected);
  if (anyAvailable && (!startV || !startV.available)) {
    selected = variants.filter(function (v) { return v.available; })[0].options.slice();
  }

  function hintFor(i) {
    var visible = $$('[data-opt="' + i + '"]').filter(function (b) { return !b.hidden; });
    var ok = visible.filter(function (b) {
      var test = selected.slice(); test[i] = b.dataset.value;
      var tv = findVariant(test); return tv && tv.available;
    }).map(function (b) { return b.dataset.value; });
    if (ok.length === visible.length || !ok.length) return '';
    var others = selected.filter(function (_, j) { return j !== i; }).join(' / ');
    return (others ? 'In ' + others + ': ' : 'Available in ') + ok.join(', ') + '.';
  }

  function update() {
    var v = findVariant(selected);
    $$('[data-opt]').forEach(function (b) {
      var i = +b.dataset.opt;
      b.setAttribute('aria-pressed', String(selected[i] === b.dataset.value));
      var test = selected.slice(); test[i] = b.dataset.value;
      var tv = findVariant(test);
      var off = !tv || !tv.available;
      b.setAttribute('data-unavailable', String(off));
      var base = b.dataset.value;
      b.setAttribute('aria-label', off ? base + ' (sold out in this combination)' : base);
    });
    $$('[data-opt-name]').forEach(function (el) { el.textContent = selected[+el.dataset.optName]; });
    $$('[data-opt-hint]').forEach(function (el) { el.textContent = hintFor(+el.dataset.optHint); });
    var restock = $('#restock-note');
    if (restock) restock.hidden = anyAvailable;

    var price = v ? money(v.price) : '';
    if (price) { $('#price').textContent = price; $('#sticky-price').textContent = price; }
    $('#quantity').textContent = quantity;
    $('#qty-minus').disabled = quantity <= 1;

    var label = !v ? 'Unavailable combination' : (v.available ? 'Add to cart' : 'Sold out');
    $('#add-button').firstElementChild.textContent = label;
    $('#sticky-add').textContent = label + ' →';
    var off = !v || !v.available;
    $('#add-button').disabled = off; $('#sticky-add').disabled = off;
    $('#selection-status').textContent = selected.join(', ') + '. ' + (price || label) + (v && !v.available ? '. Sold out.' : '.');
    return v;
  }

  function choose(i, value) {
    selected[i] = value;
    var exact = findVariant(selected);
    if (!exact || !exact.available) {
      // Keep the customer's choice and move the other options to the closest combination in stock.
      var alt = variants.filter(function (v) { return v.available && v.options[i] === value; })[0];
      if (alt) selected = alt.options.slice();
    }
    var v = update();
    if (v && v.featured_image && v.featured_image.src) {
      setMain(v.featured_image.src, v.featured_image.alt || (config.name + ', ' + v.title), v.title);
    } else if (v) {
      $('#image-label').textContent = v.title;
    }
    if (v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  $$('[data-opt]').forEach(function (b) {
    b.addEventListener('click', function () { choose(+b.dataset.opt, b.dataset.value); });
  });
  $$('.thumb').forEach(function (b) {
    b.addEventListener('click', function () { setMain(b.dataset.src, b.dataset.alt, ''); });
  });
  $('#qty-minus').addEventListener('click', function () { quantity = Math.max(1, quantity - 1); update(); });
  $('#qty-plus').addEventListener('click', function () { quantity += 1; update(); });

  function addToCart() {
    if (submitting) return;
    var v = findVariant(selected);
    if (!v || !v.available) return;
    submitting = true;
    $('#add-button').disabled = true; $('#sticky-add').disabled = true;
    fetch(config.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: quantity }] })
    }).then(function (r) {
      return r.json().then(function (res) {
        if (!r.ok) throw new Error(res.description || 'We could not add this item. Please try again.');
        window.location.assign(config.cartUrl);
      });
    }).catch(function (e) {
      submitting = false; update();
      var s = $('#selection-status'); s.classList.remove('sr-only'); s.textContent = e.message;
    });
  }
  $('#add-button').addEventListener('click', addToCart);
  $('#sticky-add').addEventListener('click', addToCart);

  function openDialog(id) {
    var d = $('#' + id); if (!d) return;
    lastFocus = document.activeElement;
    if (id === 'zoom-dialog') {
      $('#zoom-image').src = $('#main-photo').src;
      $('#zoom-image').alt = $('#main-photo').alt;
      $('#zoom-label').textContent = $('#image-label').textContent || config.name;
    }
    d.showModal();
  }
  $$('[data-open]').forEach(function (b) { b.addEventListener('click', function () { openDialog(b.dataset.open); }); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { b.closest('dialog').close(); }); });
  $$('dialog').forEach(function (d) {
    d.addEventListener('close', function () { if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    });
  });

  var shipping = {
    us: ['Free shipping on every US order.', 'Orders ship within 2–4 business days. Estimated delivery: 5–9 days.', '30-night trial. Change-of-mind returns: a $10 return-shipping fee is deducted from the refund. Damaged or faulty items: no fee.'],
    intl: ['We ship worldwide. International rates are shown at checkout and in our Shipping Policy.', 'Orders ship within 2–4 business days. Estimated delivery: up to 17 days. Import duties or taxes may apply.', '30-night trial. Change-of-mind returns: a $10 return-shipping fee is deducted from the refund. Damaged or faulty items: no fee.']
  };
  function updateRegion() {
    var el = $('#region-details'); el.innerHTML = '';
    shipping[$('#region').value].forEach(function (t) { var p = document.createElement('p'); p.textContent = t; el.appendChild(p); });
  }
  $('#region').addEventListener('change', updateRegion);
  updateRegion();
  update();
})();
